var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"close-left-side-panel d-flex justify-end align-center"},[_c('v-tooltip',{attrs:{"top":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('img',_vm._g(_vm._b({staticClass:"cursor-pointer close-icon",attrs:{"src":require("@/assets/icons/feasibility/close.svg"),"alt":""},on:{"click":_vm.closePanel}},'img',attrs,false),on))]}}])},[_c('span',[_vm._v("Close selection")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }